import { render, staticRenderFns } from "./AbsaAccounts.vue?vue&type=template&id=77e9b7c4&scoped=true"
import script from "./AbsaAccounts.vue?vue&type=script&lang=js"
export * from "./AbsaAccounts.vue?vue&type=script&lang=js"
import style0 from "./AbsaAccounts.vue?vue&type=style&index=0&id=77e9b7c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e9b7c4",
  null
  
)

export default component.exports